export const siteConfig = {
  companyName: 'AR Holdings Group Corporation',
  shortName: 'AR Holdings Group',
  domain: 'thearholdings.group',
  website: 'https://thearholdings.group',
  copyrightYear: 2026,
  reportingYear: 2025,
  enquiryEmail: '1arholdingsgroup@gmail.com',
  emails: {
    legal: 'legal@thearholdings.group',
    business: 'business@thearholdings.group',
    info: 'info@thearholdings.group',
  },
  logo: {
    light: '/logo.png',
    dark: '/logo-dark.png',
  },
  arAgent: {
    name: 'AR',
    title: 'AR Inquiry Assistant',
    tagline: 'How can we help you today?',
  },
};

export const inquiryTypes = [
  { value: 'general', label: 'General Inquiry' },
  { value: 'investment', label: 'Investment Opportunities' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'media', label: 'Media Inquiry' },
  { value: 'careers', label: 'Careers' },
];
